import { Component, OnInit } from '@angular/core';
import { NotificationInterface } from '../../../models/notification.interface';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { Subscription } from 'rxjs';
import { NotificationService } from '../../../services/notification.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-popup-notification',
  templateUrl: './popup-notification.component.html',
  styleUrls: ['./popup-notification.component.scss']
})
export class PopupNotificationComponent implements OnInit {

  notifications: NotificationInterface[] = [];
  isNotificationsLeft = false;
  notificationTotalCount = 0;

  private notificationsSubscription: Subscription;

  private notificationSkip = 0;

  constructor(private readonly notificationService: NotificationService,
              private readonly snackbarService: SnackbarService,
              private readonly translateService: TranslateService) {
    this.setTrad();
  }

  ngOnInit(): void {
    this.getNotifications();
  }

  getNotifications() {
    if (this.notificationsSubscription) {
      this.notificationsSubscription.unsubscribe();
    }

    this.notificationsSubscription = this.notificationService.getNotifications(this.notificationSkip, this.notificationTake).subscribe(notificationsResponse => {
      this.notifications = [...this.notifications, ...notificationsResponse.items];
      this.notificationSkip += this.notificationTake;
      this.isNotificationsLeft = notificationsResponse.pageInfo.hasNextPage;
      this.notificationTotalCount = notificationsResponse.totalCount;
    });
  }

  closeAllNotifications() {
    this.notificationService.closeAllNotifications().subscribe(notifications => {

      this.notifications = [];
      this.notificationSkip = 0;

      this.getNotifications();
      console.log(notifications);
    });
  }

  onNotificationClosed(notificationId: number) {
    this.notificationService.closeNotification(notificationId, this.notificationSkip).subscribe(_ => {
      this.notifications = [];
      this.notificationSkip = 0;
      this.getNotifications();
    });
  }

  getTextMessage(notification: NotificationInterface) {
    const params = notification.param.split(',');
    const message = 'mainNav.notificationsMenu.' + (notification.code.toLowerCase() + '.' + params[0]).toLowerCase();
    if (params.length > 1) {
      const args: Record<string, string> = {};
      const idx = 0;
      params.slice(1).forEach(p=> {
        args[`arg${idx}`] = p;
      });

      return this.translateService.instant(message, args) as string;
    } else {
      return this.translateService.instant(message) as string;
    }
  }

  private get notificationTake() {
    return 3;
  }

  private setTrad(): void {
    marker('mainNav.notificationsMenu.text.warn_import_worklist_exist');
    marker('mainNav.notificationsMenu.text.err_import_worklist_patient_not_found');
    marker('mainNav.notificationsMenu.text.err_import_worklist_modality_not_found');
    marker('mainNav.notificationsMenu.text.warn_import_worklist_modality_type_different');
    marker('mainNav.notificationsMenu.text.clinic_registration_asked');
    marker('mainNav.notificationsMenu.text.clinic_registration_accepted');
    marker('mainNav.notificationsMenu.text.clinic_registration_confirmed');
    marker('mainNav.notificationsMenu.text.scc_study_need_review');
    marker('mainNav.notificationsMenu.text.scc_study_start_review');
  }
}
